
import { useTranslation, Trans } from "react-i18next";

import powerful from '../../img/Home/powerful.png'

import p1 from '../../img/Home/p1.svg';
import p2 from '../../img/Home/p2.svg';
import p3 from '../../img/Home/p3.svg';
import p4 from '../../img/Home/p4.svg';
import p5 from '../../img/Home/p5.svg';

import { Fade } from 'react-awesome-reveal';

import Button from "../Button";

function PowerfulTrading() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <div className="flex flex-col md:flex-row justify-between">
                <div>
                    <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#FFF] xl:max-w-[605px]">
                        <Trans>{t("main.41")}</Trans>
                    </p>
                    <p className="xl:max-w-[497px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
                        {t("main.42")}
                    </p>
                </div>
                <div className="mt-[40px] xl:mt-0">
                    <Fade direction="right"><img src={powerful} alt="" /></Fade>
                </div>
            </div>
            <div className="mt-[40px] md:mt-0">
                <p className="zen-dots leading-[1.2] text-[16px] xl:text-[20px] text-[#FFF]">
                    <Trans>{t("main.43")}</Trans>
                </p>
                <div className="grid grid-cols-2 md:flex xl:h-[120px] max-w-[1220px] relative z-20 xl:mx-auto mt-[40px] gap-y-[20px]">
                    <div className="md:p-[20px] flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col">
                        <img src={p1} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]"/>
                        <p className="text-[#FFFFFFB2] ibm-plex text-[14px] mt-[20px] xl:mt-auto">{t("main.44")}</p>
                    </div>
                    <div className="md:p-[20px] flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col">
                        <img src={p2} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]"/>
                        <p className="text-[#FFFFFFB2] ibm-plex text-[14px] mt-[20px] xl:mt-auto">{t("main.45")}</p>
                    </div>
                    <div className="md:p-[20px] flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col">
                        <img src={p3} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]"/>
                        <p className="text-[#FFFFFFB2] ibm-plex text-[14px] mt-[20px] xl:mt-auto">{t("main.46")}</p>
                    </div>
                    <div className="md:p-[20px] flex-grow xl:w-[244px] md:border-t md:border-b md:border-l border-[#47475E] flex flex-col">
                        <img src={p4} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]"/>
                        <p className="text-[#FFFFFFB2] ibm-plex text-[14px] mt-[20px] xl:mt-auto">{t("main.47")}</p>
                    </div>
                    <div className="md:p-[20px] flex-grow xl:w-[244px] md:border border-[#47475E] flex flex-col">
                        <img src={p5} alt="" className="w-[32px] h-[32px] xl:w-[40px] xl:h-[40px]"/>
                        <p className="text-[#FFFFFFB2] ibm-plex text-[14px] mt-[20px] xl:mt-auto">{t("main.48")}</p>
                    </div>
                </div>
            </div>
            <Button className={"mt-[40px] mr-auto xl:ml-auto"} />
        </div>
    </div>
  );
}

export default PowerfulTrading;
